import {Directive, ElementRef, EventEmitter, HostListener, Output} from "@angular/core";


@Directive({
    selector: "[tigClickedOutside]"
})
export class ClickedOutsideDirective
{


    /**
     * Function > Constructor
     * @param {ElementRef} OBJ_element_ref
     */
    constructor(private OBJ_element_ref: ElementRef) {} // end constructor

    @Output()
    public onClickedOutside = new EventEmitter<any>();

    @HostListener("document:click", ["$event.target"])
    public onClick(OBJ_target_element)
    {

        let BOO_clicked_inside = this.OBJ_element_ref.nativeElement.contains(OBJ_target_element);
        if (!BOO_clicked_inside)
        {
            this.onClickedOutside.emit({clickedOutside: true});
        } // end if

    } // end function onClick


} // end class ClickedOutsideDirective